module.exports = __webpack_public_path__ + "static/0055-99cec11f2b182609eadd0cea161dbb99.png";